import React from 'react';
import { Percent, TrendingUp, Building2 } from 'lucide-react';

const CommissionSummary = ({ transactions, currency }) => {
  const COMMISSION_RATE = 0.20;
  const DRIVER_RATE = 0.80;

  const completedRidePayments = (transactions || [])?.filter(
    tx => tx?.status === 'completed' && tx?.ledger_type === 'credit' &&
    (tx?.category === 'ride_payment' || tx?.category === 'delivery_payment')
  );

  const totalEarnings = completedRidePayments?.reduce((sum, tx) => sum + parseFloat(tx?.amount || 0), 0);
  const estimatedFare = totalEarnings / DRIVER_RATE;
  const estimatedCommission = estimatedFare * COMMISSION_RATE;

  const formatAmount = (val) => new Intl.NumberFormat('en-KE', { minimumFractionDigits: 2 })?.format(val || 0);

  return (
    <div className="bg-[#0d1f3c] rounded-2xl border border-white/10 p-5">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-9 h-9 rounded-xl bg-[#ffd700]/20 flex items-center justify-center">
          <Percent className="w-4 h-4 text-[#ffd700]" />
        </div>
        <div>
          <h3 className="text-white font-semibold">Commission Summary</h3>
          <p className="text-white/40 text-xs">80/20 split model</p>
        </div>
      </div>

      {/* Split visualization */}
      <div className="mb-5">
        <div className="flex items-center justify-between mb-2">
          <span className="text-white/50 text-xs">Driver (80%)</span>
          <span className="text-white/50 text-xs">Platform (20%)</span>
        </div>
        <div className="h-3 rounded-full bg-white/10 overflow-hidden flex">
          <div className="h-full bg-gradient-to-r from-[#ffd700] to-[#ffed4a] rounded-l-full" style={{ width: '80%' }} />
          <div className="h-full bg-gradient-to-r from-[#0a1628] to-[#1a2f50] flex-1" />
        </div>
        <div className="flex items-center justify-between mt-1">
          <span className="text-[#ffd700] text-xs font-semibold">80%</span>
          <span className="text-white/30 text-xs font-semibold">20%</span>
        </div>
      </div>

      {/* Stats */}
      <div className="space-y-3">
        <div className="flex items-center justify-between bg-white/5 rounded-xl p-3">
          <div className="flex items-center gap-2">
            <TrendingUp className="w-4 h-4 text-[#ffd700]" />
            <span className="text-white/60 text-sm">Your Earnings (80%)</span>
          </div>
          <span className="text-[#ffd700] font-semibold text-sm">{currency || 'KES'} {formatAmount(totalEarnings)}</span>
        </div>

        <div className="flex items-center justify-between bg-white/5 rounded-xl p-3">
          <div className="flex items-center gap-2">
            <Building2 className="w-4 h-4 text-white/40" />
            <span className="text-white/60 text-sm">Platform Commission (20%)</span>
          </div>
          <span className="text-white/50 font-semibold text-sm">{currency || 'KES'} {formatAmount(estimatedCommission)}</span>
        </div>

        <div className="flex items-center justify-between bg-white/5 rounded-xl p-3 border border-white/10">
          <span className="text-white/60 text-sm">Estimated Gross Fare</span>
          <span className="text-white font-semibold text-sm">{currency || 'KES'} {formatAmount(estimatedFare)}</span>
        </div>
      </div>

      {/* Formula note */}
      <div className="mt-4 bg-[#ffd700]/5 border border-[#ffd700]/20 rounded-xl p-3">
        <p className="text-[#ffd700]/60 text-xs text-center">
          Commission locked at trip completion · Never recalculated
        </p>
      </div>
    </div>
  );
};

export default CommissionSummary;
